import { IInputProperty } from '@/screens/Order/interface/common.interface'
import { Button, Checkbox, Input, Select, Modal, Form, Col, Row } from 'antd'
import { DeleteOutlined, WarningFilled } from '@ant-design/icons'

import './AddProperty.style.less'
import { useEffect } from 'react'
import { FIELD_INPUT_TYPE_ARRAY } from '../../../Order.constant'
import { isEmptyValue } from '@/utils/common'

interface Props {
  open: boolean
  item: IInputProperty
  onRemove: (value: IInputProperty) => void
  onCreate: (value: any) => void
  onUpdate: (value: any) => void
  onClose: () => void
  errorExistField: boolean
}

export default function AddProperty(props: Props) {
  const [form] = Form.useForm()

  useEffect(() => {
    if (props.item) {
      form.setFieldsValue({
        label: props.item.name,
        dataType: props.item.data_type,
        required: props.item.required,
      })
    }
  }, [props.item])

  useEffect(() => {
    if (!props.open) {
      form.resetFields()
    }
  }, [props.open])

  const handleRemove = () => {
    props.onRemove(props.item)
  }

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        if (!isEmptyValue(props.item)) {
          props.onUpdate(values)
        } else {
          props.onCreate(values)
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info)
      })
  }

  return (
    <Modal
      open={props.open}
      title={props.item ? 'Edit Property' : 'Add a Property'}
      className="add-property-container"
      onCancel={props.onClose}
      centered
      maskClosable={false}
      footer={[
        <div key="action" className="flex-center">
          {props.item && (
            <Button
              key="remove"
              type="default"
              size="large"
              icon={<DeleteOutlined />}
              style={{ width: '100%', border: '2px solid #848484' }}
              onClick={handleRemove}
            >
              Remove
            </Button>
          )}
          <Button
            key="save"
            type="primary"
            size="large"
            style={{ width: '100%' }}
            onClick={handleSave}
          >
            Save
          </Button>
        </div>,
      ]}
      style={{ borderRadius: 8, overflow: 'hidden' }}
    >
      <Form
        form={form}
        name="form_in_modal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ required: false }}
      >
        <Form.Item
          name="label"
          label="Name"
          rules={[
            {
              required: true,
              message: 'This field is required',
            },
          ]}
        >
          <Input placeholder="" size="large" />
        </Form.Item>
        <Form.Item
          name="dataType"
          label="Data type"
          rules={[
            {
              required: true,
              message: 'This field is required',
            },
          ]}
        >
          <Select disabled={!!props.item}>
            {FIELD_INPUT_TYPE_ARRAY.map((item) => (
              <Select.Option key={item} value={item}>
                {item.toUpperCase()}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="required" valuePropName="checked">
          <Checkbox>Required</Checkbox>
        </Form.Item>
      </Form>
      {props.errorExistField && (
        <p className="error-text-property">
          This Property already exist in the current order
        </p>
      )}
      {props.item && (
        <Row>
          <Col span={2}>
            <WarningFilled className="icon" />
          </Col>
          <Col span={22}>
            <span>
              Saving will update the existing property. Are you sure you want to
              proceed?
            </span>
          </Col>
        </Row>
      )}
    </Modal>
  )
}
